import styled from "styled-components";

const DimmerWrapper = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.9);
    z-index: 140;
    opacity: 0.5;
    visibility: visible;
    pointer-events: auto;
`

export { DimmerWrapper }